"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ShortIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_3870_2347)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.784 6.011c-.22-.123-.43-.256-.68-.4.25-.151.479-.284.699-.408a2.732 2.732 0 001.415-2.815C11.97.515 9.798-.569 8.154.363c-1.683.96-3.367 1.902-5.03 2.89-1.32.79-1.512 1.836-1.301 3.072.134.77.65 1.34 1.33 1.73.238.134.468.267.726.42-.287.17-.545.323-.823.465a2.737 2.737 0 00-.956 3.623 2.787 2.787 0 003.758 1.132 392.887 392.887 0 004.352-2.492c.344-.2.708-.38 1.014-.627 1.54-1.274 1.31-3.585-.44-4.565zm-5.136 3.12V4.974l3.615 2.073L5.648 9.13z"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_3870_2347"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 0h14v14H0z"
  })))))
});
ShortIcon.displayName = 'ShortIcon';
var _default = exports.default = ShortIcon;